import { LiveUser } from 'shared/types/global'
import Button from 'shared/ui/Button_2'
import Flex from 'shared/ui/Flex'
import LiveAvatarsRow from 'shared/ui/LiveAvatarsRow'
import Selector from 'shared/ui/Selector'

import Logo from './components/Logo'
import LogoContainerLink from './components/LogoContainerLink'
import {
  HeaderContainer,
  IconsContainer,
  StyledHeader
} from './style'

export type HeaderProps = {
  liveUsers?: LiveUser[]
  RightComponent?: React.ReactNode
  onBack?: () => void
  tabs?: string[]
}

const Header = ({
  liveUsers,
  RightComponent,
  onBack,
  tabs
}: HeaderProps) => {
  return (
    <StyledHeader>
      <HeaderContainer>
        <Flex alignItems="center">
          {onBack && (
            <IconsContainer>
              <Button
                onPress={onBack}
                size="lg"
                intent="sub-action"
                textId={'Tools.add.page'}
                iconName="arrow_narrow_left"
                icon="only"
              />
            </IconsContainer>
          )}

          <LogoContainerLink to="/">
            <Logo />
          </LogoContainerLink>
        </Flex>
        {tabs ? (
          <Flex>
            <Selector options={tabs} disabled={[]} />
          </Flex>
        ) : null}
        <Flex columnGap={48}>
          <Flex alignItems="center">
            <LiveAvatarsRow liveUsers={liveUsers || []} />
          </Flex>

          {!!RightComponent && (
            <Flex alignItems="center">{RightComponent}</Flex>
          )}
        </Flex>
      </HeaderContainer>
    </StyledHeader>
  )
}

export default Header
